import e from "./_Symbol.js";
var o = Object.prototype, c = o.hasOwnProperty, f = o.toString, r = e ? e.toStringTag : void 0;
function p(t) {
  var a = c.call(t, r), n = t[r];
  try {
    t[r] = void 0;
    var i = !0;
  } catch (s) {
  }
  var g = f.call(t);
  return i && (a ? t[r] = n : delete t[r]), g;
}
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getRawTag.js
// module id = 1514
// module chunks = 67